import { HANDLE_CHANGE_REPORT_DATE_CONTROLS } from './../actions/reportDateControlsActions'

const initialState = {
  isDateControlsOpen: true
}

const reportDateControlsReducer = (state = initialState, action) => {
  switch (action.type) {
    case HANDLE_CHANGE_REPORT_DATE_CONTROLS: {
      return Object.assign(
        {},
        state,
        {
          isDateControlsOpen: action.data
        }
      )
    }
    default:
      return state
  }
}

export default reportDateControlsReducer